"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.showLoadingSpinner = showLoadingSpinner;
exports.hideLoadingSpinner = hideLoadingSpinner;
function showLoadingSpinner(elementToDisable) {
    document.body.prepend('<div id="loading" class="loading"><div class="spinner spinner--lg spinner--brand"><span class="sr-only">Loading...</span></div></div>');
    if (elementToDisable) {
        let classNames = elementToDisable.getAttribute("class");
        classNames += " disabled";
        elementToDisable.setAttribute("class", classNames);
        elementToDisable.setAttribute("disabled", "disabled");
    }
}
function hideLoadingSpinner(elementToEnable) {
    if (document.getElementById("loading")) {
        document.getElementById("loading").remove();
    }
    else {
        document.getElementsByClassName("loading")[0].remove();
    }
    if (elementToEnable) {
        elementToEnable.removeAttribute('disabled');
        elementToEnable.setAttribute("class", elementToEnable.getAttribute("class").replace("disabled", ""));
    }
}
